import * as React from 'react';
import { Link } from 'gatsby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUserGroup,
  faHouse,
  faRankingStar,
  faBookOpen,
  faNewspaper,
  faBoxesStacked,
  faHandFist,
  faScroll,
  faGun
} from '@fortawesome/free-solid-svg-icons';
import { useLocation } from '@reach/router';
import { Nav } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../../state/Store';
import { ToggleMenu } from '../../../layout/actions/Layout.actions';

export const NIKKEMenu: React.FC = () => {
  const pathFragments = useLocation()
    .pathname.split('/')
    .filter((p) => p && p.trim().length > 0);
  const activeKey = pathFragments.length < 1 ? 'home' : pathFragments[0];

  const model = useSelector((state: RootState) => ({
    layout: state.layout
  }));

  const dispatch = useDispatch();

  const handleOnClick = () => {
    if (model.layout.isMenuVisible === true) {
      dispatch(ToggleMenu());
    }
  };

  return (
    <Nav className="ms-auto" activeKey={activeKey}>
      <Link to="/nikke/">
        <Nav.Link as="span" eventKey="home" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faHouse} width="18" /> <span>Home</span>
        </Nav.Link>
      </Link>
      <Link to="/nikke/characters">
        <Nav.Link as="span" eventKey="characters" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faUserGroup} width="18" />{' '}
          <span>Characters</span>
        </Nav.Link>
      </Link>
      <Link to="/nikke/tier-list">
        <Nav.Link as="span" eventKey="tier-list" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faRankingStar} width="18" />{' '}
          <span>Tier list</span>
        </Nav.Link>
      </Link>
      <hr />
      <Link to="/nikke/guides/skill-investment">
        <Nav.Link as="span" eventKey="skill" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faScroll} width="18" />{' '}
          <span>Skill Investment</span>
        </Nav.Link>
      </Link>
      <Link to="/nikke/guides/overload-gear-recommendations">
        <Nav.Link as="span" eventKey="skill" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faHandFist} width="18" />{' '}
          <span>Overload Gear</span>
        </Nav.Link>
      </Link>
      <Link to="/nikke/guides/harmony-cubes-suggestions">
        <Nav.Link as="span" eventKey="skill" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faBoxesStacked} width="18" />{' '}
          <span>Harmony Cubes</span>
        </Nav.Link>
      </Link>
      <hr />
      <Link to="/nikke/guides/">
        <Nav.Link as="span" eventKey="guides" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faBookOpen} width="18" /> <span>Guides</span>
        </Nav.Link>
      </Link>
      <Link to="/nikke/guides/pvp-intro">
        <Nav.Link as="span" eventKey="skill" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faGun} width="18" /> <span>PVP Guides</span>
        </Nav.Link>
      </Link>
      <hr />
      <a href="https://blog.prydwen.gg/category/nikke/">
        <Nav.Link as="span" eventKey="blog">
          <FontAwesomeIcon icon={faNewspaper} width="18" /> <span>Blog</span>
        </Nav.Link>
      </a>
    </Nav>
  );
};
